'use client';

import { Navbar } from "./navbar";
import { NextIntlClientProvider } from "next-intl";
import { defaultLocale } from "@/i18n/config";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";

// Load messages for different locales at build time
const getMessages = (locale: string) => {
  try {
    return require(`@/messages/${locale}.json`);
  } catch (error) {
    console.warn(`Could not load messages for locale: ${locale}, falling back to default`);
    return require("@/messages/en.json");
  }
};

export function NavbarWrapper() {
  const params = useParams();
  const locale = params?.locale || defaultLocale;
  const [messages, setMessages] = useState(() => getMessages(String(locale)));
  
  // Update messages when locale changes, but use the same approach for SSR and client
  useEffect(() => {
    setMessages(getMessages(String(locale)));
  }, [locale]);

  return (
    <NextIntlClientProvider locale={String(locale)} messages={messages}>
      <Navbar />
    </NextIntlClientProvider>
  );
} 